(function () {
	'use strict';

	const modules = [];

	angular.module('demosModule', modules);
})();
